import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationUpdateSavedDocumentTextRatingArgs,
  BackendSavedDocumentTextRating,
} from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateSavedDocumentTextRating($id: ID!, $value: SavedDocumentRatingEnum!) {
    updateSavedDocumentTextRating(id: $id, value: $value) {
      id
    }
  }
`;

type Variables = BackendMutationUpdateSavedDocumentTextRatingArgs;
type Result = Pick<BackendSavedDocumentTextRating, 'id'>;

export const updateSavedDocumentTextRating = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
